<script>
    // -- IMPORTS

    import { enabledAdminView } from '../../store/adminStore.js';
    import { isLoadingStore } from '../../store/isLoadingStore';
    import Loading from './Loading.svelte';

    // -- VARIABLES

    /** @type {{fullWidth?: boolean, invertColor?: boolean, type?: string, style?: any, disabled?: boolean, href?: any, variant?: string, loading?: boolean, children?: import('svelte').Snippet, onclick?: () => void}} */
    let {
        fullWidth = false,
        invertColor = false,
        type = 'button',
        style = null,
        disabled = false,
        href = null,
        variant = '',
        loading = false,
        children,
        onclick = () => {}
    } = $props();
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- ELEMENTS

    button,
    a
    {
        max-height: 3.5rem;
        min-width: 2.5rem;
        border: 1px solid lightGoldColor;
        border-radius: .5rem;
        padding: 0.75rem 1.25rem;

        display: flex;
        gap: 1rem;
        justify-content: center;
        align-items: center;

        background-color: darkGreyColor;

        font-size: 1rem;
        font-weight: 600;
        text-transform: uppercase;
        color: lightGoldColor;

        cursor: pointer;
        text-wrap: nowrap;
        width: fit-content;

        transition: all 0.2s ease-in-out;

        +media( smaller-desktop )
        {
            width: 100%;
            max-width: unset;
        }
    }

    button[disabled]
    {
        pointer-events: none;
        cursor: not-allowed;
    }

    button.full-width,
    a.full-width,
    {
        width: 100%;
        max-width: unset;
    }

    button.invert-color,
    a.invert-color
    {
        border: 1px solid lightGoldColor;

        background: lightGoldColor;

        color: darkGreyColor;
    }

    button:hover,
    a:hover,
    {
        background-color: lightGoldColor;

        color: darkGreyColor;
    }

    button.invert-color:hover,
    a.invert-color:hover,
    {
        background-color: darkGreyColor;

        color: lightGoldColor;
    }

    button:disabled,
    button[disabled]
    {
        background-color: darkGreyColor;

        color: lightGoldColor;

        pointer-events: all;
        cursor: not-allowed;
    }

    // -- CLASSES

    .error
    {
        border-color:  redColor500;

        background: darkGreyColor;

        color: redColor500;
    }

    .error:hover,
    .error:focus
    {
        border-color:  transparent;

        background: #ef535080;

        color: redColor500;
    }
</style>

{#if href}
    <a class="{ variant }" href={ href } class:full-width={ fullWidth } class:invert-color={ invertColor } style={ style } { type } onclick={ onclick } class:is-admin-enabled={ $enabledAdminView }>
        {@render children?.()}
    </a>
{:else}
    <button class={ variant } class:full-width={ fullWidth } class:invert-color={ invertColor } style={ style } { type } disabled={ loading || disabled || $isLoadingStore } onclick={ onclick } class:is-admin-enabled={ $enabledAdminView }>
        {#if loading}
            <Loading
                color=
                { variant === 'error'
                    ? '#ef5350'
                    : '#ADA58C'
                }
            />
        {:else}
            {@render children?.()}
        {/if}
    </button>
{/if}
